import { render } from "./GroupedChart.vue?vue&type=template&id=584c1c85&ts=true"
import script from "./GroupedChart.vue?vue&type=script&lang=ts"
export * from "./GroupedChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__